export const FEATURES = [
  {
    name: "subcontractor_tree",
    feature_key: "subcontractor_tree",
  },
];
